import React from 'react'
import { Chip, ChipProps } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import WarningIcon from '@mui/icons-material/Warning'
import PendingIcon from '@mui/icons-material/Pending'
import CancelIcon from '@mui/icons-material/Cancel'

export type StatusType = 'success' | 'error' | 'warning' | 'pending' | 'cancelled' | 'info'

interface StatusChipProps extends Omit<ChipProps, 'color'> {
  status: StatusType
  text?: string
  showIcon?: boolean
}

const statusConfig: Record<StatusType, { color: ChipProps['color']; icon: React.ReactNode; defaultText: string }> = {
  success: {
    color: 'success',
    icon: <CheckCircleIcon />,
    defaultText: 'Completado',
  },
  error: {
    color: 'error',
    icon: <ErrorIcon />,
    defaultText: 'Error',
  },
  warning: {
    color: 'warning',
    icon: <WarningIcon />,
    defaultText: 'Advertencia',
  },
  pending: {
    color: 'default',
    icon: <PendingIcon />,
    defaultText: 'Pendiente',
  },
  cancelled: {
    color: 'default',
    icon: <CancelIcon />,
    defaultText: 'Cancelado',
  },
  info: {
    color: 'info',
    icon: <CheckCircleIcon />,
    defaultText: 'Información',
  },
}

export const StatusChip: React.FC<StatusChipProps> = ({
  status,
  text,
  showIcon = true,
  variant = 'filled',
  size = 'small',
  ...chipProps
}) => {
  const config = statusConfig[status]
  
  return (
    <Chip
      label={text || config.defaultText}
      color={config.color}
      variant={variant}
      size={size}
      icon={showIcon ? (config.icon as React.ReactElement) : undefined}
      {...chipProps}
    />
  )
}

export default StatusChip